import React from 'react'
import { DashboardModule } from '@domain-group/suit-theme'

import NavigationItem from './NavigationItem'

type Step = {
  complete?: boolean,
  key: string,
  label: string,
  body: string,
  onClick?: (step: Step) => void,
}

interface StepNavigationProps {
  activeStepKey: string,
  callbacks: {
    setCurrentStepKey: (step: Step) => void,
  },
  steps: Step[],
}

const StepNavigation = (props: StepNavigationProps) => {
  const { activeStepKey, callbacks, steps } = props
  const { setCurrentStepKey } = callbacks || {}

  const activeStepIndex = steps.findIndex(step => step.key === activeStepKey)

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Steps">
      {steps.map((step, index) => {
        const {
          body, complete, key, label,
        } = step

        return (
          <NavigationItem
            body={body}
            callbacks={{
              onClick: () => setCurrentStepKey(step),
            }}
            isActive={activeStepKey === key}
            isComplete={complete ?? index < activeStepIndex}
            isFirst={index === 0}
            isLast={steps.length === index + 1}
            key={key}
            label={label}
            stepNumber={index + 1}
          />
        )
      })}
    </DashboardModule>
  )
}

StepNavigation.Item = NavigationItem

export default StepNavigation
